import { lazy } from 'react';

export const SignUpPage = lazy(() => import('./signUp'));
export const SignUpVcfcPage = lazy(() => import('./signUpVcfc'));
